<template>
  <div class="keyword-index">
    <el-dialog
      top="15vh"
      @close="close"
      append-to-body
      :show-close="false"
      width="752px"
      @open="open"
      custom-class="keyword-dialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="keyword-wrap">
        <div class="keyword-header">
          <div class="header-left">
            <span class="keyword-tips">
              <span class="el-icon-arrow-right" /><span
                class="el-icon-arrow-right"
              /><span class="el-icon-arrow-right" />
              <span style="font-size: 18px"
                >选择您感兴趣的关键词,将为您推荐更多优质内容</span
              >
            </span>
          </div>
          <div class="header-right">
            <!-- <div class="close-icon-wrap">
              <span
                class="close-icon el-icon-close pointer"
                @click="close"
              ></span>
            </div> -->
            <div
              class="skip-btn"
              @click.stop="skipStep"
              v-if="triggerEvent == 'first-login'"
            >
              跳过
            </div>
          </div>
        </div>
        <div class="keyword-main">
          <el-skeleton :loading="dataLoading">
            <div class="keyword-list">
              <div
                class="keyword"
                :class="{ act: hasList.includes(keyword.id) }"
                :key="keyword.id"
                v-for="keyword in dataList"
                @click="keywordTap(keyword)"
              >
                {{ keyword.key_word }}
              </div>
            </div>
            <div class="keyword-list" slot="template">
              <el-skeleton-item
                variant="rect"
                class="tmp"
                :key="tmp"
                v-for="tmp in 16"
              ></el-skeleton-item>
            </div>
          </el-skeleton>
          <div class="btn-wrap">
            <template v-if="triggerEvent == 'first-login'">
              <el-button
                type="primary"
                round
                style="width: 336px"
                :disabled="dataLoading"
                @click="confirm($event)"
                >进入</el-button
              >
            </template>
            <template v-else-if="triggerEvent == 'update'">
              <el-button
                round
                @click="close"
                style="width: 200px"
                :disabled="dataLoading"
                >取消</el-button
              ><el-button
                round
                type="primary"
                style="width: 200px"
                :disabled="dataLoading"
                @click="confirm($event)"
                >确定</el-button
              >
            </template>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "keyword-index",
  data() {
    return {
      dialogVisible: false,
      dataTotal: 0,
      dataList: [],
      dataLoading: false,
      hasList: [], // 已选择
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    visibleKey: {
      type: String,
      required: true,
      validator: function (val) {
        return typeof val == "string" && val != "";
      },
    },
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    triggerEvent: {
      type: String,
      default: "first-login", // first-login、  update
    },
  },
  watch: {
    visible: {
      handler: function (val) {
        this.dialogVisible = val;
      },
      deep: true,
    },
    list: {
      handler(list) {
        this.hasList = list;
      },
    },
  },
  methods: {
    // 关闭模态框
    close() {
      this.$emit("switchModal", this.visibleKey, false);
    },
    async fetchKeywordList() {
      try {
        const params = {
          page_num: 1,
          page_size: 99999,
          cond_list: [],
        };
        this.dataLoading = true;
        const resp = await this.$fetch({
          url: "/My/getKeywordList",
          method: "POST",
          data: params,
        });
        this.dataLoading = false;
        const { state, data } = resp || {};
        if (state !== 0) return;
        const { row_list = [], rows_count = 0 } = data || {};
        this.dataList = row_list || [];
        this.dataTotal = rows_count || 0;
      } catch (error) {
        this.dataLoading = false;
        // eslint-disable-next-line no-empty
      }
    },
    keywordTap(keyword) {
      const { id } = keyword;
      if (!this.hasList.includes(id)) this.hasList.push(id);
      else this.hasList = this.hasList.filter((it) => it !== id);
    },
    open() {
      this.fetchKeywordList();
    },
    /* 跳过 */
    skipStep() {
      this.$emit("confirm");
      this.close();
    },
    async confirm(eTarget) {
      if (!this.hasList.length)
        return this.$message.warning({
          message: "请选择感兴趣的内容",
          offset: 80,
        });
      try {
        const params = this.hasList.map((it) => it);
        const resp = await this.$fetch({
          url: "/My/addUserResumeKeyWord",
          method: "POST",
          data: params,
          eTarget,
        });
        if (resp.state === 0) {
          this.$emit("confirm");
          this.close();
        }
      } catch (error) {
        /* eslint-disable-next-line no-empty */
      }
    },
  },
  created() {
    // this.fetchKeywordList();
  },
};
</script>
<style lang="scss">
.keyword-dialog {
  border-radius: 10px !important;
  .el-dialog__header {
    padding: 0 !important;
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
    margin: 0 !important;
  }
  .keyword-wrap {
    width: 752px;
    font-size: 14px;
    border-radius: 10px;
    .keyword-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      border-bottom: 0.5px solid;
      border-image: linear-gradient(
          90deg,
          rgba(238, 234, 255, 1),
          rgba(148, 125, 254, 0)
        )
        1 1;

      .keyword-tips {
        color: #303133;
      }
      .close-icon-wrap {
        width: 40px;
        height: 40px;
        background-color: #f5f5f5;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        .close-icon {
          font-size: 20px;
        }
      }
      .skip-btn {
        cursor: pointer;
        &:hover {
          color: var(--color-primary);
        }
      }
    }
    .keyword-main {
      padding: 16px 0;
      border-radius: 10px;
      background: linear-gradient(360deg, #e5eaf6 0%, #ffffff 100%);
      .keyword-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        min-height: 120px;
        max-height: 400px;
        gap: 20px 16px;
        align-items: flex-start;
        padding: 2px 40px;
        .keyword {
          overflow: hidden;
          text-align: center;
          min-width: 60px;
          width: fit-content;
          padding: 8px 14px;
          border-radius: 1000px;
          font-size: 16px;
          color: var(--color-dark);
          background-color: #fff;
          cursor: pointer;
          transition: all 0.45;
          box-shadow: 0px 0px 2px 0.1px lightgray;
          &.act,
          &:hover {
            background-color: var(--color-primary);
            color: #fff;
          }
        }
        .tmp {
          height: 32px;
          width: 70px;
          border-radius: 32px;
          box-shadow: 0px 0px 2px 0.1px lightgray;
          &:nth-child(2n) {
            width: 110px;
          }
          &:nth-child(3n) {
            width: 95px;
          }
          &:nth-child(5n) {
            width: 100px;
          }
        }
      }
      .btn-wrap {
        margin-top: 20px;
        padding: 20px;
        text-align: center;
      }
    }
  }
}
</style>
